<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle">EMAIL UNVERIFIED</H1>

                <div class="limitWidth has-text-white">
                <div class="is-size-4 top40">
                    Your Email has not been Verified!
                </div>
                <p class="top20">
                    Please check your email for a confirmation and instructions on how to verify your account.
                    After doing so, click the button below to login.
                </p>
                <p class="top10">
                    If you have not received the email in your inbox please check your junk-email. You can also click
                    <a href="" @click.prevent="resend" class="has-text-warning">here</a> to have it resent.
                </p>
                <p v-show="showMsg" class="has-text-weight-bold top10">
                    A new confirmation email has been sent to your email address.
                </p>
                <div class="top20">
                    <button class="button is-warning" @click="$root.showModalLogin({})">LOG IN</button>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
export default {
  components: {
    MainLayout
  },
  data: function () {
    return {
      showMsg: false
    }
  },
  methods: {
    resend: function () {
      var self = this
      this.showMsg = false

      this.$root.azCognito.resendConfirmationCode(this.$root.userAttrs.email, resendCallback)

      function resendCallback (result, obj) {
        if (result == 'success') {
          self.showMsg = true
        } else if (result == 'error') {
          self.$root.showModalOK({message: 'There was an error resending the verificatoin email. Please try again.'})
        }
      }
    }
  }
}
</script>

<style scoped>
    a {
        font-weight: bold;
    }
    a:hover{
        color:gold
    }
</style>



// WEBPACK FOOTER //
// src/pages/Unverified.vue